module.exports = __webpack_public_path__ + "img/034-newspaper.a2649907.svg";